import {Component, EventEmitter, Input, Output} from "@angular/core";
import {IValueChangedEvent} from "../../../wizard.content";
import { filter } from 'lodash';
import { UserAuth } from '@nrwl/common-lib';

@Component({
  selector: "wizard-user-to-role",
  templateUrl: "./user.to.role.html",
  styleUrls: ["../wizard.user.style.scss"]
})
export class UserToRoleComponent {
  @Input() step: any;
  @Input() wizardCtrl: any;
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  filterDataSource = ['monitor'];
  flipValue(role) {
    if (!role.disabled) {
      this.selectRole(role);
    }
    this.onDataValueChange.emit({
      componentId: 'add_users_to_roles',
      key: 'roleIds',
      newValue: filter(this.step.dataSource, {isChecked: true}),
      isValid: true
    });
  }

  selectRole(role) {
    role.isChecked = !role.isChecked;
  }
  clickDetected() {
    return false;
  }
 
   isLoading() {
    return this.wizardCtrl.getWizardService().isLoading;
  }
}
